import * as types from '@/store/mutation-types'

export default {
    namespaced: true,
    state: {
        centerId: null,
		user: null,
		permissions: null,

		url: '',

		centers: null,
        canUseControlPanel: null,
        canUseEdunixManager: null,
        cauUseEdunixTransport: null
    },

    actions: {
        login ({ commit }, { userName, centerId, password }) {
			return window.axios.post(`/center/${centerId}/user/${userName}/login`, null, {
                headers: {
                    'X-Password': password || ''
                }
            }).then((response) => {
                commit(types.LOGIN, {
                    centerId: centerId,
                    userName: userName,
                    password: password,
                    name: response.data.FullName,
                    permissions: response.data.Permissions,
                    canUseEdunixManager: response.data.CanUseEdunixManager,
                    canUseControlPanel: response.data.CanUseControlPanel,
                    cauUseEdunixTransport: response.data.CauUseEdunixTransport
                })
                return response.data
            })
        },

        fetchCenters ({ commit }) {
			return window.axios.get('/centers').then((res) => {
				commit(types.STORE_CENTERS, res.data)
				return res.data
			})
		},

        logout ({ commit }) {
			commit(types.LOGOUT)
		}
    },

    mutations: {
        [types.LOGIN] (state, user) {
			console.log('loging in...')

			state.user = user
			state.centerId = user.centerId
			state.permissions = user.permissions

			state.url = `/center/${user.centerId}/manager/${user.userName}`

			localStorage.setItem('auth', JSON.stringify(state.user))

			window.axios.defaults.headers['X-Password'] = user.password

            state.canUseControlPanel = user.canUseControlPanel
            state.canUseEdunixManager = user.canUseEdunixManager
            state.cauUseEdunixTransport = user.cauUseEdunixTransport
            console.log('useeeer', user)
		},

        [types.STORE_CENTERS] (state, centers) {
            state.centers = centers
        },

        [types.LOGOUT] (state) {
			console.log('loging out...')

			state.user = null
			state.centerId = null
			state.permissions = null

			state.url = ''

			localStorage.setItem('auth', JSON.stringify(null))

			delete window.axios.defaults.headers['X-Password']
		}
    }
}
